"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setForm = void 0;
var setForm = function (updateForm) { return function (newState) {
    return updateForm({ key: "__no__Key", value: newState, actionType: "set" });
}; };
exports.setForm = setForm;
//# sourceMappingURL=setForm.js.map